<template>
  <div>
    <SelectGroup
      icon="selectvh"
      rightSpan="53px"
      class="row-item mb15"
      pointClass="j-select-server"
      selectClass="j-select-server-ele-uid"
      v-model="serverId"
      @change="loadRole('select_bind')"
    >
      <template slot="option">
        <option value="0" disabled>
          {{ letter.creatework_serverHolder }}
        </option>
        <optgroup :label="letter.yourServer">
          <option
            v-for="item in historyServerList"
            :key="item.ID"
            :value="item.ID"
          >
            {{ item.NAME }}
          </option>
        </optgroup>
        <optgroup :label="letter.allServer">
          <option v-for="item in serverList" :key="item.ID" :value="item.ID">
            {{ item.NAME }}
          </option>
        </optgroup>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </SelectGroup>
    <Select
      v-if="roleList && roleList.length !== 0"
      icon="selectvh"
      rightSpan="53px"
      class="row-item role-select mb15"
      pointClass="j-select-role"
      selectClass="j-select-role-ele-uid"
      v-model="roleId"
      @change="loadProduct"
    >
      <template slot="option">
        <option value="-1" disabled>
          {{ letter.selectRoleName }}
        </option>
        <option
          v-for="item in roleList"
          :key="item.roleID"
          :value="item.roleID"
        >
          {{ item.roleName }}
        </option>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </Select>
    <Select
      v-else
      icon="selectvh"
      rightSpan="53px"
      class="row-item mb15"
      v-model="roleId"
      pointClass="j-select-role"
      selectClass="j-select-role-ele-uid"
      @change="loadProduct"
    >
      <template slot="option">
        <option value="-1" disabled v-if="!serverId">
          {{ letter.selectRoleName }}
        </option>
        <option value="-1" disabled v-else>
          {{ letter.creatework_noRole }}
        </option>
      </template>
      <template slot="ico">
        <em class="ico"></em>
      </template>
    </Select>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import {
  GET_SERVER_LIST,
  GET_ROLE_LIST,
  GET_PRODUCT_LIST,
  UPDATE_LOADING
} from '@store/officialStore';
import globalConfig from '@utiles/officialStore/globalConfig';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import coupon from '@mixins/officialStore/coupon';
import login from '@mixins/officialStore/login';
import { updateCommonParamsInfo } from '@plugins/biPoint/commonParam';
const mapServerIdBypcServerId = (pcServerId, serverList) => {
  let serverId = '';
  try {
    for (let item of serverList) {
      if (item.SID === pcServerId) {
        serverId = item.ID;
        break;
      }
    }
  } catch (e) {
    serverId = '';
  }
  return serverId;
};
export default {
  mixins: [coupon, login],
  data() {
    return {
      select: '',
      ico: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      serverList: state => state.serverList,
      historyServerList: state => state.historyServerList,
      roleList: state => state.roleList
    })
  },
  watch: {
    gameId: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.selectRole();
        this.loadGameCouponList();
        if (this.$store.getters.gameInfoConfig.isVipScore) {
          this.loadVipCouponInfo();
        }
      }
    }
  },
  methods: {
    selectRole() {
      let serverId = globalConfig.getHrefParam('server_id') || null;
      //pcServerId 厂商的serverId（简码）。serverId后端的用的server_id（全码）
      let pcServerId = globalConfig.getHrefParam('serverId') || null;

      this.$store.commit(UPDATE_LOADING, true);
      this.$store.dispatch(GET_SERVER_LIST).then(serverList => {
        this.$store.commit(UPDATE_LOADING, false);
        if (!serverId && pcServerId) {
          serverId = mapServerIdBypcServerId(pcServerId, serverList.history); // 先匹配历史选择过的服务器
          if (serverId === '') {
            serverId = mapServerIdBypcServerId(pcServerId, serverList.all); // 历史中选择过的服务器没有找到才全部搜一遍
          }
        }
        if (this.gameId && serverId) {
          // 如果是储值页返回的，设置默认伺服器、获取角色列表、更新当前角色
          this.serverId = serverId;
          this.$store
            .dispatch(GET_ROLE_LIST, serverId)
            .then(({ roleId }) => {
              this.roleId = roleId;
              if (
                this.roleId != -1 &&
                this.roleId != null &&
                this.roleId != undefined
              ) {
                updateCommonParamsInfo({
                  roleId: this.roleId,
                  roleName: this.roleName,
                  serverId: this.serverId
                });
                window.webstorev1DataLayer.push({
                  eventName: 'bind',
                  eventValue: {
                    role_id: this.roleId,
                    role_name: this.roleName,
                    server_id: this.serverId
                  },
                  eventReason: 'auto_bind'
                });
                this.$store.dispatch(GET_PRODUCT_LIST);
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      });
    },
    loadProduct() {
      if (this.roleId && this.roleId !== -1) {
        this.$store.dispatch(GET_PRODUCT_LIST);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/officialStore.scss';
.row-item {
  display: block;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto 23px;
  width: 100%;
  background-size: cover;
  vertical-align: top;
  font-size: 24px;
  color: var(--input-role);
  @psetbg ('role-choose.png');
  ::v-deep .select {
    color: var(--input-role) !important;
  }
  &.mb15 {
    margin-bottom: 15px;
  }
}
.ico {
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  @psetbg ('role-ico.png');
}
</style>
